// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errMsg {
  color: red;
  font-style: italic;
}

.vehicleButtonSection {
  margin-bottom: 10px;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.marginBtn {
  margin-right: 10px !important;
}

.successMsg {
  color: green;
  font-style: italic;
  padding-bottom: 20px;
}
.search-icon-style {
  stroke: #001489;
  cursor: pointer;
}
.button-container-parts-form {
  margin-bottom: 10px;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/survey/styles/PartForm.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".errMsg {\n  color: red;\n  font-style: italic;\n}\n\n.vehicleButtonSection {\n  margin-bottom: 10px;\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.marginBtn {\n  margin-right: 10px !important;\n}\n\n.successMsg {\n  color: green;\n  font-style: italic;\n  padding-bottom: 20px;\n}\n.search-icon-style {\n  stroke: #001489;\n  cursor: pointer;\n}\n.button-container-parts-form {\n  margin-bottom: 10px;\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
